import { useQuery, UseQueryOptions } from 'react-query';
import {
  GetTenantsRequest,
  GetTenantsResponse,
  TenantAPI,
} from '@weave/schema-gen-ts/dist/schemas/phone/tenant/tenant_api.pb';
import { authorizedFetch } from 'helpers/utils';

const phoneTenantQueryKeys = {
  base: ['phone-tenant'],
  getPhoneTenants: (orgId: string) => [...phoneTenantQueryKeys.base, 'tenants', orgId],
};

const CACHE_TIME = 1000 * 60 * 60; // 1 hour

const useGetPhoneTenants = <T = GetTenantsResponse>(
  request: GetTenantsRequest,
  options?: UseQueryOptions<GetTenantsResponse, Error, T>
) => {
  return useQuery({
    queryKey: phoneTenantQueryKeys.getPhoneTenants(request.orgId),
    queryFn: async () => TenantAPI.GetTenants(authorizedFetch(), request),
    retry: false,
    ...options,
    enabled: !!request.orgId && (options?.enabled ?? true),
    cacheTime: CACHE_TIME,
    staleTime: CACHE_TIME,
  });
};

export const PhoneTenantQueries = {
  useGetPhoneTenants,
};
